import { useEffect, useState } from 'react';
import {
    GetReportError,
    useGetReport,
} from '@thought-river/negotiations-common/dist/api/contractContent';
import { ContractsReport } from '@thought-river/negotiations-common/dist/api/contractContent';
import { DEFAULT_REACT_QUERY_REFETCH_INTERVAL } from '@modules/common/types';
import {
    REPORTS_MAX_CELL_COUNT,
    getReprocessingContractsCount,
} from '@modules/reports/portfolioReports';

export const useGetReportData = (
    reportId: string
): {
    reportData: ContractsReport | undefined;
    reportLoading: boolean;
    reportError: GetReportError | null;
    updateReportDataFetchInterval: (interval: number) => void;
} => {
    const [reportDataRefetchInterval, setReportDataRefetchInterval] = useState(
        DEFAULT_REACT_QUERY_REFETCH_INTERVAL
    );

    //Get report data hook
    const {
        data: reportData,
        isLoading: reportLoading,
        error: reportError,
    } = useGetReport(
        {
            queryParams: {
                report_definition_id: Number(reportId),
                error_if_limit_exceeded: false,
                max_number_of_cells: REPORTS_MAX_CELL_COUNT,
            },
        },
        {
            refetchInterval: reportDataRefetchInterval,
        }
    );

    //Change report data refetch interval back to 10 minutes if there are no contracts being reprocessed
    useEffect(() => {
        if (!reportData?.rows) {
            return;
        }

        const reprocessingContractsCount =
            getReprocessingContractsCount(reportData);

        if (reprocessingContractsCount === 0) {
            setReportDataRefetchInterval(DEFAULT_REACT_QUERY_REFETCH_INTERVAL);
        }
    }, [reportData]);

    return {
        reportLoading,
        reportError,
        reportData,
        updateReportDataFetchInterval: setReportDataRefetchInterval,
    };
};
